// extracted by mini-css-extract-plugin
export default {"containerDiv":"PersonalSettingsCard_containerDiv__2F6ct"};